export enum ChargeTypeEnum {
    PER_SQFT = "Per SQ.FT",
    PER_UNIT = "Per Unit"
}
